<template>
  <div id="auto-collections"><h1>auto collections</h1></div>
</template>

<script>
export default {
  name: 'AutoCollections'
}
</script>

<style lang="scss" scoped></style>
